import { render, staticRenderFns } from "./editHoliday.vue?vue&type=template&id=4ab264a2&scoped=true&"
import script from "./editHoliday.vue?vue&type=script&lang=js&"
export * from "./editHoliday.vue?vue&type=script&lang=js&"
import style0 from "./editHoliday.vue?vue&type=style&index=0&id=4ab264a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab264a2",
  null
  
)

export default component.exports